@if(content.layout === 'simple') {
<sirius-navigation-menu-simple
    [text]="content.menu.moreInfoText"
    [logo]="{
        url: 'assets/header-logo-desktop.svg',
        link: { href: content.menu.siteRoot.href, title: '' }
    }"
    [link]="content.menu.moreInfoLink">
</sirius-navigation-menu-simple>
} @else {
<sirius-navigation
    #navigation
    [menuGroups]="content.menu.topMenuGroups"
    [logos]="['assets/header-logo-mobile.svg', 'assets/header-logo-desktop.svg']"
    [siteRoot]="content.menu.siteRoot"
    [searchPageUrl]="content.search.searchPageUrl"
    [profileEnabled]="false"
    [profileMenuOptions]="content.menu.profileMenu.menuItems"
    [ctaButton]="content.menu.headerCta ?? undefined">
</sirius-navigation>
}
